/* eslint-disable prettier/prettier */
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import { userAgenda } from '../../../agenda/store/agenda.selectors';
import { useSyncedWorkshopSessions } from '../../../workshop-session/store/workshopSessions.hooks';
import { useSyncedWorkshops } from '../../../workshops/store/workshops.hooks';
import { useAutoRefresh } from '../../../utils/hooks';
import { hasActiveLive, upcomingLiveSession } from '../../../workshops/utils/session.utils';
import { matchDefinedValues } from '../../../utils';
import { useStoreCollectionSync } from '../../../utils/useVersionSync';
import { throttledFetchWorkshops } from '../../../workshops/store/workshops.actions';
import { throttledFetchWorkshopSessions } from '../../../workshop-session/store/workshopSessions.actions';

export function useCloudTvSessions({ mode = 'agenda' }) {
  const sessions = useSyncedWorkshopSessions();
  const workshops = useSyncedWorkshops();
  const agenda = useSelector(userAgenda);
  if (mode === 'agenda') {
    return agenda;
  }
  if (mode === 'sessions') {
    return sessions;
  }
  if (mode === 'workshops') {
    return workshops;
  }
  return [];
}

export function useCurrentCloudTvSession(mode, { forceLiveStream, workshopFilter }) {
  const now = useAutoRefresh(60000);
  const agenda = useCloudTvSessions({ mode });

  useStoreCollectionSync({ resourceType: 'workshops', fetcher: throttledFetchWorkshops });
  useStoreCollectionSync({
    resourceType: 'workshopSessions',
    fetcher: throttledFetchWorkshopSessions,
  });
  return useMemo(() => {
    const filteredAgenda = agenda.filter(matchDefinedValues(workshopFilter));
    const upcomingLive = upcomingLiveSession(filteredAgenda, now);
    if (forceLiveStream) return { upcomingLive, hasCurrentLive: true };
    const hasCurrentLive = hasActiveLive(upcomingLive);
    return { upcomingLive, hasCurrentLive };
  }, [mode, workshopFilter, agenda]);
}
